import React from 'react';
import Item from './Item';

const Timeline = ({ data, fetched_data, history }) => {

    if (!fetched_data) {
        return (
            <div className="tl-container" style={{color: '#999'}}>
                <div className="text-center">
                    <i className="material-icons" style={{fontSize: '4.2em'}}>timeline</i>
                </div>

                <p className="text-center">
                    Informe o dia e o veículo para consultarmos a linha do tempo.
                </p>
            </div>
        );
    }

    if (!data.length) {
        return (
            <div className="tl-container" style={{color: '#999'}}>
                <div className="text-center">
                    <i className="material-icons" style={{fontSize: '4.2em'}}>sentiment_very_dissatisfied</i>
                </div>
                <p className="text-center">Nenhum registro encontrado.</p>
            </div>
        );
    }

    const items = data.map((timeline, key) => {
        return (<Item data={timeline} key={key} />);
    });

    return (
        <div className="tl-container">
            {items}
        </div>
    );

}

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/Timeline/index.js